var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2F2E2E",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.895.354.707.707L1.561 25.102l-.707-.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.854 1.06 1.56.355l24.041 24.041-.707.707z"
  }))));
};
export default SvgClose;